<template>
    <Dialog title="费用详情" v-model="visible" :footer="false">
        <div class="m-auto w-[375px]">
            <div v-for="(item, index) in info.feeList || []" :key="index" class="border-b">
                <div class="mb-[15px]">{{ formatTime(item.startTime) }} 至 {{ formatTime(item.endTime) }}</div>
                <div class="flex items-center justify-between text-sm mb-[10px]">
                    <div class="text-hui">时长费（{{ item.duration }}分钟）</div>
                    <div>{{ formatMoney(item.durationMoney) }}元</div>
                </div>
                <div class="flex items-center justify-between text-sm">
                    <div class="text-hui">里程费（{{ item.mileage }}公里）</div>
                    <div>{{ formatMoney(item.mileageMoney) }}元</div>
                </div>
                <div class="border-b"></div>
                <div class="flex justify-end mb-[10px]">
                    <div>合计 {{ formatMoney(item.durationMoney + item.mileageMoney) }}元</div>
                </div>
                <div class="flex items-center justify-between">
                    <div>限价扣减</div>
                    <div class="text-theme">-{{ formatMoney(item.deductFee) }}元</div>
                </div>
                <div v-if="info.type === 2" class="text-xs text-hui mt-2">{{ item.feeRuleDescribe }}</div>
            </div>
            <div class="flex items-center justify-between mb-[40px]">
                <div>实际应付</div>
                <div>{{ formatMoney(info.payFee) }}元</div>
            </div>
            <div class="text-hui text-xs m-auto " v-if="info.type === 1">
                <div class="rule-title">计价规则：{{ parsedRules[0]?.ruleName || '--' }}</div>
                <!-- <div class="rule-limits">
                    日限价 {{ formatMoney(parsedRules[0]?.maxDayFee) || '--' }} | 月限价 {{
                        formatMoney(parsedRules[0]?.maxMonthFee) || '--' }}
                </div> -->
                <div class="rule-limits">
                    日限价 {{ parsedRules[0]?.maxDayFee !== undefined && parsedRules[0]?.maxDayFee !== null ?
                        formatMoney(parsedRules[0]?.maxDayFee) : '--' }}
                    | 月限价 {{ parsedRules[0]?.maxMonthFee !== undefined && parsedRules[0]?.maxMonthFee !== null ?
                        formatMoney(parsedRules[0]?.maxMonthFee) : '--' }}
                </div>
                <table class="rule-table" v-if="parsedRules.length > 0">
                    <thead>
                        <tr>
                            <th>时间段</th>
                            <th>时长费(元)</th>
                            <th>里程费(元)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(rule, idx) in parsedRules" :key="idx">
                            <td>{{ formatTimeRange(rule.minDate) }} - {{ formatTimeRange(rule.maxDate) }}</td>
                            <td>{{ formatMoney(rule.durationFee) }}/分钟</td>
                            <td>{{ formatMoney(rule.mileageFee) }}/公里</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!-- <div class="text-hui text-xs m-auto w-max" v-if="info.type === 1">计价规则：{{ formatMoney(info.feeRule?.durationFee) }}元/分钟，{{
            formatMoney(info.feeRule?.mileageFee) }}元/公里，每车自然日内限价{{ formatMoney(info.feeRule?.maxFee) }}元</div> -->



    </Dialog>
</template>
  
<script >
import { orderFeeDetail } from '@/api/rental';
import { ref, computed, watch, getCurrentInstance } from 'vue';
const __sfc_main = {};
__sfc_main.props = {
  modelValue: {
    type: Boolean,
    default: false
  },
  orderId: {
    type: [String, Number],
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    proxy
  } = getCurrentInstance();
  const emit = __ctx.emit;
  const props = __props;

  // 详情
  const info = ref({});
  function getInfo() {
    orderFeeDetail(props.orderId).then(res => {
      info.value = res;
    });
  }
  // 解析 ruleContent
  const parsedRules = computed(() => {
    if (!info.value.ruleContent) return [];
    try {
      const rules = typeof info.value.ruleContent === 'string' ? JSON.parse(info.value.ruleContent) : info.value.ruleContent;
      return rules;
    } catch (e) {
      console.error('解析 ruleContent 失败', e);
      return [];
    }
  });

  // 时间段格式化：1100 -> 11:00
  function formatTimeRange(timeStr) {
    if (!timeStr) return '--:--';
    if (timeStr === '0000') return '00:00';
    if (timeStr === '2359') return '23:59';
    return timeStr.slice(0, 2) + ':' + timeStr.slice(2);
  }
  const visible = ref(false);
  watch(() => props.modelValue, val => {
    visible.value = val;
    if (val) {
      getInfo();
    }
  }, {
    immediate: true
  });
  watch(() => visible.value, val => {
    emit('update:modelValue', val);
  });
  return {
    info,
    parsedRules,
    formatTimeRange,
    visible
  };
};
export default __sfc_main;
</script>

<style scoped lang="scss">
.border-b {
    border-bottom: 1px solid #e5e7eb;
    padding-bottom: 15px;
    margin-bottom: 15px;
}

.rule-wrapper {
    margin-top: 16px;
    padding-top: 12px;
    border-top: 1px solid #e5e7eb;
}

.rule-title {
    font-weight: 600;
    font-size: 15px;
    color: #333;
}

.rule-limits {
    font-size: 15px;
    color: #666;
    margin: 2px 0 6px 0;
}

.rule-table {
    border-collapse: collapse;
    font-size: 14px;
    width: 100%;
}

.rule-table th,
.rule-table td {
    padding: 2px 12px 2px 0;
    text-align: left;
    white-space: nowrap;
}

.rule-table th {
    font-weight: 500;
    color: #999;
}

.rule-table td {
    color: #333;
}
</style>
